// Simple logger utility
/* eslint-disable no-console */
const logger = {
  info: (message, data = null) => {
    console.log(`[INFO] ${message}`, data || '');
  },
  
  error: (message, data = null, error = null) => {
    console.error(`[ERROR] ${message}`, data || '', error || '');
  },
  
  warn: (message, data = null) => {
    console.warn(`[WARN] ${message}`, data || '');
  },
  
  debug: (message, data = null) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[DEBUG] ${message}`, data || '');
    }
  },
  
  // Specific logging functions for course creation
  courseCreation: (action, data = null, error = null) => {
    if (error) {
      logger.error(`Course Creation ${action}`, data, error);
    } else {
      logger.info(`Course Creation ${action}`, data);
    }
  },
  
  documentAnalysis: (action, data = null, error = null) => {
    if (error) {
      logger.error(`Document Analysis ${action}`, data, error);
    } else {
      logger.info(`Document Analysis ${action}`, data);
    }
  },
  
  apiCall: (method, endpoint, requestData = null, responseData = null, duration = null) => {
    const message = `API ${method} ${endpoint}`;
    const data = {
      request: requestData,
      response: responseData,
      duration: duration ? `${duration}ms` : null
    };
    logger.info(message, data);
  }
};

export default logger;
